export default __webpack_public_path__ + "static/media/10.1c222792.svg";